import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    addRecord,
    addRecordSuccess,
    addRecordFailure,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    deleteRecord,
    deleteRecordSuccess,
    deleteRecordFailure
} from './dossier-invoice.action';



import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { DossierInvoicesTableService } from './dossier-invoice-table.service';
import { fetchSingleRecordSuccess as dossierRecordSuccess } from '../Dossier/dossier.action';
import { RootReducerState } from '..';
import { Store } from '@ngrx/store';
import { RouterService } from 'src/app/core/services/router.service';
import { HelperService } from 'src/app/core/services/helper.service';


@Injectable()
export class DossierInvoicesRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data) => {
                const url = 'dossier-invoice/'+data.id+'/invoice'+"?club="+this.moduleTableService.clubId;
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const listData = data.records;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: listData, total: total});

                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                
                const dossierId = data.dossierId;
                const url = `dossier-invoice/${data.dossierId}/invoice/${data.id}/edit`;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(dossierRecordSuccess({singleData: data.dossier, dossierData: {countryList: [], clubs: [], categories: [], seasons: []}}));

                        return fetchSingleRecordSuccess({singleData: data.record, paymentTypes: data.payment_types});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");

                                if(this.moduleTableService.clubId && this.moduleTableService.clubId != "0"){
                                    this.routeService.triggerRoute(null, `/clubs/${this.moduleTableService.clubId}/payment-history`, { activeTab: 'invoices' });
                                }else{
                                    this.routeService.triggerRoute(null, `/dossiers/detail/${data.dossierId}`, { activeTab: 'invoices' });
                                }

                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    addData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addRecord),
            exhaustMap((data: any) => {
                const url = `dossier-invoice/${data.dossierId}/invoice`;
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, `/dossiers/detail/${data.dossierId}`, { activeTab: 'invoices' });
                        return addRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => addRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );
    
    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'dossier-invoice-update/'+data.dossierId+'/'+data.id;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");

                        if(this.moduleTableService.clubId && this.moduleTableService.clubId != "0"){
                            this.routeService.triggerRoute(response, `/clubs/${this.moduleTableService.clubId}/payment-history`, { activeTab: 'invoices' });
                        }else{
                            this.routeService.triggerRoute(response, `/dossiers/detail/${data.dossierId}`, { activeTab: 'invoices' });
                        }
                        
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );
    
    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                const url = 'dossier-invoice/'+data.dossierId+"/invoice/"+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        
                        this.alertService.triggerAlert(response.message, "success");

                        if(this.moduleTableService.clubId && this.moduleTableService.clubId != "0"){
                            this.store.dispatch(fetchRecords({id: "0"}));
                            this.routeService.triggerRoute(response, `/clubs/${this.moduleTableService.clubId}/payment-history`, { activeTab: 'invoices' });
                        }else{
                            this.store.dispatch(fetchRecords({id: data.dossierId}));
                            this.routeService.triggerRoute(response, `/dossiers/detail/${data.dossierId}`, { activeTab: 'invoices' });
                        }

                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private moduleTableService: DossierInvoicesTableService,
        private tableService: DatatableService,
        private store: Store<RootReducerState>,
        private routeService: RouterService,
        public helperService: HelperService
    ) { }

}